import clients from '@/services/api/clients'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { toast } from 'react-toastify'

// import { Container } from './styles';

function Row({ client, onUpdate, onRemoved }) {
  const [loading, setLoading] = useState(false)

  async function onConfirmRemove() {
    try {
      setLoading(true)
      await clients.destroy(client.id)
      onRemoved(client)
      toast.success('Client removido com sucesso')
    } catch (e) {
      toast.error(e?.message ?? 'Erro ao remover client')
    } finally {
      setLoading(false)
    }
  }

  function onPressRemove() {
    confirmAlert({
      title: 'Remover Client',
      message: `Confirma a remoção do client ${client.clientName}?`,
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim, remover',
          className: 'bg-error',
          onClick: onConfirmRemove,
        },
      ],
    })
  }

  async function onConfirmDeactivate() {
    try {
      setLoading(true)
      await clients.deactivate(client.id)
      onUpdate({ ...client, active: false })
      toast.success('Client inativado com sucesso')
    } catch (e) {
      toast.error(e?.message ?? 'Erro ao inativar client')
    } finally {
      setLoading(false)
    }
  }

  function onPressDeactivate() {
    confirmAlert({
      title: 'Inativar Client',
      message: `Confirma a inativação do client ${client.clientName}?`,
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim, inativar',
          className: 'bg-error',
          onClick: onConfirmDeactivate,
        },
      ],
    })
  }

  async function onConfirmActivate() {
    try {
      setLoading(true)
      await clients.activate(client.id)
      onUpdate({ ...client, active: true })
      toast.success('Client ativado com sucesso')
    } catch (e) {
      toast.error(e?.message ?? 'Erro ao ativar client')
    } finally {
      setLoading(false)
    }
  }

  function onPressActivate() {
    confirmAlert({
      title: 'Ativar Client',
      message: `Confirma a ativação do client ${client.clientName}?`,
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim, ativar',
          className: 'bg-success',
          onClick: onConfirmActivate,
        },
      ],
    })
  }

  return (
    <tr key={client.id}>
      <td>{client.id}</td>
      <td>{client.clientName}</td>
      <td>{client.secret}</td>
      <td className={client.active ? 'text-success' : 'text-error'}>
        {client.active ? 'Ativo' : 'Inativo'}
      </td>
      <td className="text-right">
        {
          client.active ? (
            <a
              onClick={onPressDeactivate}
              className="btn btn-sm btn-action btn-primary tooltip tooltip-left"
              disabled={loading}
              data-tooltip="Inativar"
            >
              <i className="fas fa-lock" />
            </a>
          ) : (
            <a
              onClick={onPressActivate}
              className="btn btn-sm btn-action btn-success tooltip tooltip-left "
              disabled={loading}
              data-tooltip="Ativar"
            >
              <i className="fas fa-unlock" />
            </a>
          )
        }

        <a
          onClick={onPressRemove}
          className="btn btn-sm btn-action btn-error tooltip tooltip-left ml-2"
          disabled={loading}
          data-tooltip="Excluir"
        >
          <i className="fas fa-trash" />
        </a>
      </td>
    </tr>
  )
}

Row.propTypes = {
  client: PropTypes.objectOf(Object).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onRemoved: PropTypes.func.isRequired,
}

export default Row
